import { useState, useEffect } from "react";
import { WEBINAR, WEBINAR_DATE } from "../content";

const diff = (target) => {
  const ms = new Date(target).getTime() - Date.now();
  if (ms <= 0) return null;
  return {
    d: Math.floor(ms / 86400000),
    h: Math.floor((ms / 3600000) % 24),
    m: Math.floor((ms / 60000) % 60),
    s: Math.floor((ms / 1000) % 60),
  };
};

export const Countdown = () => {
  const [left, setLeft] = useState(() => (WEBINAR_DATE ? diff(WEBINAR_DATE) : null));

  useEffect(() => {
    if (!WEBINAR_DATE) return;
    const t = setInterval(() => setLeft(diff(WEBINAR_DATE)), 1000);
    return () => clearInterval(t);
  }, []);

  if (!WEBINAR_DATE || !left) {
    return (
      <div className="mono text-[13px] tracking-widest text-white" data-testid="hero-date">
        📅 {WEBINAR.dateLine}
      </div>
    );
  }

  const dateStr = new Date(WEBINAR_DATE).toLocaleString("en-US", {
    month: "long", day: "numeric", hour: "numeric", minute: "2-digit", timeZone: "America/Chicago", timeZoneName: "short",
  });

  return (
    <div data-testid="hero-countdown">
      <div className="mono text-[13px] tracking-widest text-white mb-3">📅 LIVE — {dateStr.toUpperCase()}</div>
      <div className="flex gap-3">
        {[["DAYS", left.d], ["HRS", left.h], ["MIN", left.m], ["SEC", left.s]].map(([label, v]) => (
          <div key={label} className="text-center rounded-md border border-[#FE0000]/25 bg-[#FE0000]/[0.05] px-3 py-2 min-w-[58px]" data-testid={`countdown-${label.toLowerCase()}`}>
            <div className="mono text-xl font-bold text-[#FE0000] tabular-nums">{String(v).padStart(2, "0")}</div>
            <div className="mono text-[10px] tracking-[0.25em] text-white mt-0.5">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
